// Instance
import MainAPI from '@/app/apis/main/main-api.js';

// Endpoints
import { API, ENDPOINTS } from '@/app/apis/main/_connection/connection-api.js';

// Query String
const queryString = require('querystring');

class brandAPI extends MainAPI {
	/**
	 * @return {object} list of brands
	 * @params productType
	 * */
	async getBrands(queryParams) {
		return API.get(`${ENDPOINTS.GET_BRANDS}?${queryString.stringify(queryParams)}`);
	}
}

export default new brandAPI();
